import { render, staticRenderFns } from "./ListaTaxas.vue?vue&type=template&id=8579bb5a"
import script from "./ListaTaxas.vue?vue&type=script&lang=js"
export * from "./ListaTaxas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports